"use strict";

exports.__esModule = true;
var _LayoutTemplateCollection = require("./LayoutTemplateCollection");
Object.keys(_LayoutTemplateCollection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LayoutTemplateCollection[key]) return;
  exports[key] = _LayoutTemplateCollection[key];
});